var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 122.066,
    height: 96.0001,
    viewBox: "0 0 122.066 96.0001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 95"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 34",
    y1: -0.5,
    x2: 38.4255,
    y2: -0.5,
    transform: "matrix(0.281273 -0.959628 0.959629 0.281267 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 35",
    y1: -0.5,
    x2: 65.2609,
    y2: -0.5,
    transform: "matrix(0.672192 -0.740377 0.740385 0.672184 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 36",
    y1: -0.5,
    x2: 28.722,
    y2: -0.5,
    transform: "matrix(0.996073 -0.0885388 0.0885408 0.996073 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 37",
    y1: -0.5,
    x2: 74.601,
    y2: -0.5,
    transform: "matrix(0.954481 0.298272 -0.298278 0.954479 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 38",
    y1: -0.5,
    x2: 37.4291,
    y2: -0.5,
    transform: "matrix(0.356705 0.934217 -0.93422 0.356698 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 39",
    y1: -0.5,
    x2: 38.2303,
    y2: -0.5,
    transform: "matrix(-0.997785 0.0665182 -0.0665198 -0.997785 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 40",
    y1: -0.5,
    x2: 50.638,
    y2: -0.5,
    transform: "matrix(-0.627757 -0.778409 0.778416 -0.627748 44.5041 54.6755)",
    stroke: "#1976D2",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 7",
    cx: 44.5043,
    cy: 54.6759,
    rx: 10.1722,
    ry: 10.1722,
    fill: "#112EA8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 88.3707,
    cy: 6.35763,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    cx: 54.6761,
    cy: 17.8009,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 10",
    cx: 57.8558,
    cy: 89.6424,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 11",
    cx: 6.3576,
    cy: 57.2168,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 12",
    cx: 12.715,
    cy: 15.258,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 13",
    cx: 73.1137,
    cy: 52.1328,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 14",
    cx: 115.709,
    cy: 76.9257,
    rx: 6.3576,
    ry: 6.35763,
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIllustration);
export default __webpack_public_path__ + "static/media/graph_illustration.5532f4d3956830adfa1ee87c8bbd9a49.svg";
export { ForwardRef as ReactComponent };